import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ErrorText from './ErrorText';
import Label from './Label';
import Icon from '../Icons/Icon';
import Button from '../Buttons/Button';
import DeleteButton from '../Buttons/DeleteButton';
import LazyLoad from '../Loaders/LazyLoad';
import SpinLoader from '../Loaders/SpinLoader';

export default class ImageUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageAdded: false,
      loading: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    // Check to make sure the image has been populated
    if ('value' in nextProps) {
      if (nextProps.value !== undefined) {
        if (nextProps.value.src !== '') {
          this.setState({ imageAdded: true, loading: false });
        } else {
          this.setState({ imageAdded: false });
        }
      }
    }
  }

  handleImageChange(e) {
    this.setState({ loading: true });
    this.props.onChange(e);
  }

  fakeButtonClick = (e) => {
    e.preventDefault();
    this.inputElement.click();
  }

  removeImage = (e) => {
    e.preventDefault();
    this.inputElement.value = '';
    const event = new Event('change', { bubbles: true });
    this.inputElement.dispatchEvent(event);
    this.setState({ loading: false });
  }

  render() {
    const { name, label, value, children, error, touched } = this.props;

    const wrapperClass = classNames('image-upload-input-container upload-from-device', {
      'form-group--has-error': touched && error,
      'image-added': this.state.imageAdded,
    });

    return (
      <div className={wrapperClass}>
        <Label name={name}>{label}</Label>

        {children}

        {this.state.imageAdded &&
          <div className="image-upload-preview">
            <DeleteButton onClick={(e) => { this.removeImage(e); }} />
            <img alt="" src={value.src} />
          </div>
        }

        <div className="image-upload-container">
          <Button classes="image-upload-btn btn btn--tertiary w-100" onClick={this.fakeButtonClick}>
            <Icon name="outline-add-image" size="m" fill="grey" />
            <p className="m-b-0 fw-normal">Click to add an image from your device (JPEG)</p>
            <input
              type="file"
              name={name}
              ref={(input) => { this.inputElement = input; }}
              accept="image/jpeg"
              onChange={e => this.handleImageChange(e)}
              onClick={e => e.stopPropagation()}
            />
          </Button>

          {this.state.loading &&
            <LazyLoad posAbsolute>
              <SpinLoader black />
            </LazyLoad>
          }
        </div>

        {touched && error && <ErrorText>{error}</ErrorText>}
      </div>
    );
  }
}

ImageUpload.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  error: PropTypes.string,
  touched: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
};



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/ImageUpload.js